import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { EBEpouchdbService } from '../../../../EBE/EBEpouchdb.service';
import { BookData } from '../../../../shared/models/bookData';
import { Page } from '../../../../shared/models/page';
@Component({
  selector: 'app-pagesIndex',
  templateUrl: './pagesIndex.component.html',
  styleUrls: ['./pagesIndex.component.css']
})
export class PagesIndexComponent implements OnInit {


  @Input() data: any;
  public bookObj: any;
  public pages = [];
  public filterActive: boolean = false;
  totalEnrichment;
  public pageObj: Page;
  public bookDataObj: BookData;
  public pageCount: Number = 0;
  constructor(private fb: FormBuilder, private pouchService: EBEpouchdbService) {
  }

  obj: any
  ngOnInit() {

    if (this.data && this.data.popupProps) {
      this.bookDataObj = this.data.popupProps.bookDataObj;
      this.pageCount = this.data.popupProps.pageCount;

      //To create static pages array

      if (this.data.popupProps.curComp.parent == "CreatedEBE") {
        for (let i = 0; i < this.bookDataObj.pages.length; i++) {

          if (i == 0) {

          }

          else if (i == this.bookDataObj.pages.length - 1) {

          }

          else {
            this.obj = this.bookDataObj.pages[i];
            if (this.bookDataObj[(this.obj)]) {
              // if (this.bookDataObj[i + 1].pageNumber == undefined) {
              //   this.bookDataObj[i + 1].pageNumber = i + 1;
              // }
              this.pages.push(this.bookDataObj[(this.obj)]);
            }
            else {
              this.pageObj = new Page();
              this.pageObj.pageNumber = i + 1;
              this.pages.push(this.pageObj);
            }
          }


        }
      }

      else {
        for (let i = 0; i < this.pageCount; i++) {

          if (this.bookDataObj[i + 1]) {
            if (this.bookDataObj[i + 1].pageNumber == undefined) {
              this.bookDataObj[i + 1].pageNumber = i + 1;
            }
            this.pages.push(this.bookDataObj[i + 1]);
          }
          else {
            this.pageObj = new Page();
            this.pageObj.pageNumber = i + 1;
            this.pages.push(this.pageObj);
          }

        }
      }

    }

  }


  public filterOptions = [{
    type: 'bookmarks',
    name: 'BookMarks',
    isChecked: false
  },
  {
    type: 'drawing',
    name: 'Drawing',
    isChecked: false
  },
  {
    type: 'enrichments',
    name: 'Enrichments',
    isChecked: false
  },
  {
    type: 'notes',
    name: 'Notes',
    isChecked: false
  },
  {
    type: 'annotations',
    name: 'Annotations',
    isChecked: false
  }
  ];


  onFilterClick(): void {
    this.filterActive = !this.filterActive;
    if (this.filterActive) {
      document.getElementsByClassName("globalpopup")[0]['style'].height = "317px";
      document.getElementsByClassName("globalpopup")[0]['style'].width = "280px";
    }
    else {
      document.getElementsByClassName("globalpopup")[0]['style'].height = "400px";
      document.getElementsByClassName("globalpopup")[0]['style'].width = "225px";
    }
  }

  onFilterOptionsClick(obj: any): void {
    obj.isChecked = !obj.isChecked;
  }

  onFilterAll(filterOptions): void {
    for (let opt of filterOptions) {
      opt.isChecked = true;
    }
  }
  changePdfPage(pdfInx, page) {

    if (this.data.popupProps.curComp.parent == 'ELE') { }
    else if (this.data.popupProps.curComp.parent == 'CreatedEBE') {
      parent.window.document['ebeDoc'].clickPageFromPagesIndex(page)

    }
    else parent.window.document['ebeDoc'].onNotify({ 'state': 'pagesIndex', 'pdfInx': pdfInx });
  }

}



// WEBPACK FOOTER //
// ./src/app/bookShared/enrichmentTabs/enrichmentTabPopups/pagesIndex/pagesIndex.component.ts